import { BaseService } from './BaseService';

export class AuthService extends BaseService {
  async sendOtp(body: { phone_number: string }, param?: any): Promise<{ phone_number: string }> {
    const userDetails = await window.AwsWafIntegration.fetch("/api/v1/users", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify(body)
    });
    return userDetails.json();
  }
  async verifyOtp(body: { phone_number: string; otp: string }, param?: any): Promise<{ confirmed: boolean; auth_token: string; new_record: boolean; id: number }> {
    return this.post('/api/v1/users/verify', body, param);
  }
  async resendOtp(body: { phone_number: string; type: string }, param?: any): Promise<any> {
    return this.put('/api/v1/users/resend_otp', body, param);
  }
  async logout(id: number | string): Promise<any> {
    return this.remove(`/api/v1/users/${id}/logout`);
  }
}

export default new AuthService();
